<template>
  <form id="contact-us-form" v-if="!error.refData && refData !== null && !loading" @submit.prevent novalidate>
    <FormField overrideClass="full-width" labelText="What are you contacting us about?" forId="requestType">
      <!-- <div class="dropdown-select-wrapper">
        <select id="requestType" v-model="v$.formResponse.requestType.$model">
          <option value="" disabled>Please select one</option>
          <option v-for="option in refData.contactUsAboutOptions" :key="option.returnValue" :value="option.returnValue">{{ option.display }}</option>
        </select>
        <label for="requestType" class="dropdown-face">{{ getDropdownDisplayText }}</label>
      </div> -->
      <DropdownSelect :items="contactUsAboutOptionsList" v-model="v$.formResponse.requestType.$model" />
    </FormField>

    <template v-if="isPublicSite">
      <FormField :required="isFirstNameRequired" overrideClass="full-width" labelText="First name" forId="firstName">
        <FormInput id="firstName" placeholder="e.g. John" autocomplete="given-name" v-model="v$.formResponse.firstName.$model" />
        <label class="error" v-if="v$.formResponse.firstName.$error" for="firstName">{{ getNameErrorMessage('firstName') }}</label>
      </FormField>

      <FormField :required="isLastNameRequired" overrideClass="full-width" labelText="Last name" forId="lastName">
        <FormInput id="lastName" placeholder="e.g. Citizen" autocomplete="family-name" v-model="v$.formResponse.lastName.$model" />
        <label class="error" v-if="v$.formResponse.lastName.$error" for="lastName">{{ getNameErrorMessage('lastName') }}</label>
      </FormField>
    </template>

    <FormField :required="isContactMeByRequired" v-if="formResponse.requestType == 'Joining'" overrideClass="full-width" labelText="How would you like us to contact you?">
      <ul class="radio-group large">
        <li v-for="option in refData.contactByOptions" :key="option.returnValue">
          <input v-model="v$.formResponse.contactMethod.$model" type="radio" :id="option.returnValue" :value="option.returnValue" name="contactMethod" />
          <label :for="option.returnValue">{{ option.display }}</label>
        </li>
      </ul>
    </FormField>

    <FormField
      :required="isContactMeByRequired"
      overrideClass="full-width"
      v-if="formResponse.contactMethod === refData.contactByOptions[0].returnValue || (!isContactMeByRequired && formResponse.requestType == 'Feedback')"
      labelText="Email address"
      forId="email"
    >
      <FormInput :disabled="!isPublicSite" id="email" type="email" autocomplete="email" placeholder="info@defencehealth.com.au" v-model="v$.formResponse.email.$model" />
      <label class="error" v-if="v$.formResponse.email.$error && isPublicSite" for="email">{{ emailError }}</label>
    </FormField>

    <FormField overrideClass="full-width" v-if="formResponse.contactMethod === refData.contactByOptions[1].returnValue" labelText="Phone number" forId="phone">
      <FormInput :disabled="!isPublicSite" id="phone" autocomplete="tel" placeholder="e.g. 0400 ### ###" v-model="v$.formResponse.phoneNumber.$model" />
      <label class="error" v-if="v$.formResponse.phoneNumber.$error && isPublicSite" for="phone">{{ phoneNumberError }}</label>
    </FormField>

    <FormField overrideClass="full-width" forId="requestmessage" labelText="What would you like to say?">
      <textarea id="requestmessage" cols="30" rows="10" v-model="v$.formResponse.requestmessage.$model" maxlength="1000" placeholder="Type your message here"></textarea>
      <label class="error" for="requestmessage" v-if="v$.formResponse.requestmessage.$error">This is required field.</label>
    </FormField>

    <input type="submit" :disabled="v$.$invalid" @click="submitForm" />
    <div class="radio-group large submit-wrapper"></div>

    <div v-if="isSubmitting" class="modal-screen" aria-label="submitting your query.">
      <div class="modal" role="dialog">
        <ApiLoading v-if="isSubmitting" :apiError="false" class="submit-loading" loadingMessage="We are processing your request. It shouldn't be too long." />
      </div>
    </div>
  </form>
  <ApiLoading v-else :apiError="error.refData">
    <p>Sorry, something has gone wrong, and we can’t show you all the information. Please try refreshing the page or chat to one of our friendly staff.</p>
  </ApiLoading>
</template>

<script>
import { required, maxLength, minLength, requiredIf, email } from '@vuelidate/validators';
import { ApiLoading, FormField, FormInput } from '@/components';
import { stringWithInvalidSpace, STORAGE_KEYS } from '@general/js/utils';
import { JOIN_NOW_NAME_VALIDATOR, INTERNAL_EMAIL_VALIDATOR } from '@general/js/validators';
import { ContactErrorMessage, EmailErrorMessage, NameErrorMessage } from '@general/js/enums/ErrorMessageEnum';
import SupportServicesPW from '@general/js/services/Support';
import { CONTACT_US_CONFIRMATION } from '@/router/routeNames';
import { setNavigationState } from '@/router/navigationState';
import { saveSessionObject } from '@/utils';
import { PageURLs } from '@general/js/enums/PageURLsEnum';
import { DropdownSelect } from '@general/js/components';
import useVuelidate from '@vuelidate/core';

export default {
  name: 'contactUsForm',

  setup() {
    return { v$: useVuelidate() };
  },

  components: {
    ApiLoading,
    DropdownSelect,
    FormField,
    FormInput,
  },

  props: {
    refDataPassed: {
      type: Object,
    },

    isPublicSite: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isSubmitting: false,
      error: {
        refData: false,
      },
      loading: this.isPublicSite,
      refData: this.refDataPassed ?? null,
      formResponse: {
        requestTypeDisplayText: '',
        requestType: '',
        contactMethod: '',
        email: this.isPublicSite ? '' : this.refDataPassed.email || '',
        phoneNumber: this.isPublicSite ? '' : this.refDataPassed.phoneNumber || '',
        requestmessage: '',
        firstName: this.isPublicSite ? '' : this.refDataPassed.memberName.firstName,
        lastName: this.isPublicSite ? '' : this.refDataPassed.memberName.lastName,
      },
      ContactErrorMessage,
      EmailErrorMessage,
      NameErrorMessage,
    };
  },

  watch: {
    'formResponse.requestType': {
      handler() {
        this.formResponse.requestTypeDisplayText = this.getDropdownDisplayText;

        if (this.formResponse.requestType && this.formResponse.requestType !== 'Joining' && this.isContactMeByRequired) {
          this.formResponse.contactMethod = this.refData?.contactByOptions[0]?.returnValue;
        } else if (this.formResponse.requestType === 'Joining') {
          this.formResponse.contactMethod = this.refData?.contactByOptions[1]?.returnValue;
        }
        this.v$.formResponse.email.$reset();
        this.v$.formResponse.phoneNumber.$reset();
        if (!this.isContactMeByRequired) {
          this.formResponse.contactMethod = '';
          this.formResponse.email = '';
          this.formResponse.phoneNumber = '';
        }
      },
    },

    'formResponse.contactMethod': {
      handler() {
        if (this.isPublicSite && this.isContactMeByRequired) {
          this.formResponse.email = '';
          this.formResponse.phoneNumber = '';
          this.v$.formResponse.email.$reset();
          this.v$.formResponse.phoneNumber.$reset();
        }
      },
    },

    'formResponse.email': {
      handler() {
        if (this.isPublicSite && !this.formResponse.email && !this.isContactMeByRequired) {
          this.formResponse.contactMethod = '';
        } else if (this.isPublicSite && this.formResponse.email && !this.isContactMeByRequired) {
          this.formResponse.contactMethod = 'email';
        }
      },
    },
  },

  validations: {
    formResponse: {
      requestType: {
        required,
      },
      firstName: {
        required: requiredIf(function () {
          return this.isFirstNameRequired;
        }),
        JOIN_NOW_NAME_VALIDATOR,
        stringWithInvalidSpace,
        maxLength: maxLength(160),
      },
      lastName: {
        required: requiredIf(function () {
          return this.isLastNameRequired;
        }),
        JOIN_NOW_NAME_VALIDATOR,
        stringWithInvalidSpace,
        maxLength: maxLength(160),
      },
      contactMethod: {
        required: requiredIf(function () {
          return this.isContactMeByRequired;
        }),
      },
      email: {
        email,
        required: requiredIf(function () {
          return this.formResponse.contactMethod === this.refData?.contactByOptions[0]?.returnValue && ((this.isContactMeByRequired && this.isPublicSite) || !this.isPublicSite);
        }),
        INTERNAL_EMAIL_VALIDATOR,
      },
      phoneNumber: {
        required: requiredIf(function () {
          return this.formResponse.contactMethod === this.refData?.contactByOptions[1]?.returnValue;
        }),
        maxLength: maxLength(12),
        minLength: minLength(10),
      },
      requestmessage: {
        required,
        maxLength: maxLength(1000),
      },
    },
  },

  computed: {
    emailError() {
      const validationObj = this.v$.formResponse.email;

      if (validationObj.$error && !validationObj.required) {
        return `${this.EmailErrorMessage.IS_EMPTY} Email address.`;
      }
      if (!validationObj.INTERNAL_EMAIL_VALIDATOR) {
        return this.EmailErrorMessage.IS_INTERNAL_EMAIL;
      }

      return this.EmailErrorMessage.IS_INVALID;
    },

    phoneNumberError() {
      const validationObj = this.v$.formResponse.phoneNumber;

      if (validationObj.$error && !validationObj.required) {
        return `${this.ContactErrorMessage.IS_EMPTY} Phone number.`;
      }
      return this.ContactErrorMessage.IS_INVALID_OTHERS;
    },

    getDropdownDisplayText() {
      if (this.formResponse.requestType !== '') {
        return this.refData.contactUsAboutOptions.find((option) => {
          return option.returnValue === this.formResponse.requestType;
        }).display;
      }

      return 'Please select one';
    },

    isFirstNameRequired() {
      if (!this.isPublicSite) {
        return true;
      }

      switch (this.formResponse.requestType) {
        case 'Feedback':
          return false;

        case 'Joining':
        case 'Complaint':
        case 'OtherPublic':
        default:
          return true;
      }
    },

    isLastNameRequired() {
      if (!this.isPublicSite) {
        return true;
      }

      switch (this.formResponse.requestType) {
        case 'Joining':
        case 'Complaint':
        case 'OtherPublic':
        case 'Feedback':
          return false;

        default:
          return true;
      }
    },

    isContactMeByRequired() {
      if (!this.isPublicSite) {
        return true;
      }

      switch (this.formResponse.requestType) {
        case 'Feedback':
        case 'Joining':
        case 'Complaint':
        case 'OtherPublic':
        default:
          return true;
      }
    },

    contactUsAboutOptionsList() {
      return this.refData?.contactUsAboutOptions.map((option) => {
        return { name: option.display, value: option.returnValue };
      });
    },
  },

  methods: {
    getNameErrorMessage(keyName) {
      const validationObj = this.v$.formResponse[keyName];

      if (validationObj.maxLength.$invalid) {
        return NameErrorMessage.IS_OVER_LENGTH;
      }
      if (validationObj.JOIN_NOW_NAME_VALIDATOR.$invalid || !stringWithInvalidSpace(validationObj.$model)) {
        return NameErrorMessage.IS_INVALID;
      }
      if (validationObj.required.$invalid) {
        if (keyName === 'firstName') return `${NameErrorMessage.IS_EMPTY} First name.`;
        return `${NameErrorMessage.IS_EMPTY} Last name.`;
      }

      return '';
    },

    async submitForm() {
      const payload = { ...this.formResponse };
      this.isSubmitting = true;
      this.$emit('post-error-state', false);

      if (payload.contactMethod.toLowerCase() === 'email') {
        payload.phoneNumber = '';
      } else {
        payload.email = '';
        payload.phoneNumber = payload.phoneNumber.replace(/ /g, '');
      }

      payload.public = this.isPublicSite;

      try {
        await SupportServicesPW.postContactUsFeedback(payload);

        if (this.isPublicSite) {
          saveSessionObject(payload, STORAGE_KEYS.CONTACT_US.FORM_RESPONSE);
          // if public website, redirect to confirmation page with save form response in session storage.
          document.location.href = PageURLs.CONTACT_US_CONFIRMATION;
        } else {
          // if member portal on success, redirect to confirmation page passing form response via navigationState
          setNavigationState({ formResponse: payload });
          this.$router.push({ name: CONTACT_US_CONFIRMATION });
        }
      } catch (error) {
        logger.log(error);
        this.$emit('post-error-state', true);
      } finally {
        if (!this.isPublicSite) {
          this.isSubmitting = false;
        }
      }
    },

    async publicWebsiteGetReferenceData() {
      this.loading = true;
      this.error.refData = false;
      this.refData = null;
      this.$emit('get-refernace-error-state', false);

      try {
        const data = await SupportServicesPW.getContactUsReferenceData();
        this.refData = data;
      } catch (error) {
        logger.log(error);
        this.error.refData = true;
        this.$emit('get-refernace-error-state', true);
      } finally {
        this.loading = false;
      }
    },
  },

  async beforeMount() {
    if (this.isPublicSite) {
      this.publicWebsiteGetReferenceData();
    }
  },
};
</script>

<style lang="scss" scoped>
.submit-wrapper {
  row-gap: 0;

  &:before {
    content: '';
    display: block;
  }

  input[type='submit'] {
    max-width: unset;
  }
}

.full-width {
  grid-template-columns: 1fr !important;
}

.submit-loading {
  background: $WHITE;
  min-height: unset;
}
</style>
